// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { xcDepConfig } from '@/api/depConfig.js'
import { getDepNameByDomain } from '@/utils/index'

Vue.config.productionTip = false

// 路由初始化前获取平台类型
async function initPlatformType() {
  try {
    const depName = getDepNameByDomain()
    console.log('[DEBUG] initPlatformType start, depName:', depName)
    const res = await xcDepConfig(depName)
    if (res && res.platformType) {
      store.commit('SetPlatformType', res.platformType)
      console.log('[DEBUG] initPlatformType success, platformType:', res.platformType)
    } else {
      console.log('[DEBUG] initPlatformType no platformType, default to portal')
    }
  } catch (e) {
    console.error('[DEBUG] initPlatformType error:', e)
  }
}

// 立即执行初始化，不等待
initPlatformType()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js